var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"cy",rawName:"v-cy",value:(`__${_vm.text}`),expression:"`__${text}`"}],class:[_vm.blockClassName, _vm.type, 'font-body-regular'],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }